export default "/images/circle_not_closed_previous.svg?2adf8ea6d087e2c087088f05cffeb941";